/** Protected UI lifetime, not a replacement for server-side authorization. */
let owner: object | null = null;
let generation = 0;
export function enterDataContext(next: object): () => void {
  if (owner !== next) { owner = next; generation += 1; }
  return () => { if (owner === next) { owner = null; generation += 1; } };
}

/** Capture before awaiting credentials; check before sending and after reading.
 * Late results reject instead of running the old caller's success/navigation.
 * An action already accepted by the server is not undone by this UI guard.
 */
export function dataContextGuard(): () => void {
  const expected = generation;
  return () => {
    if (generation !== expected) throw new DOMException("Der Zugriffskontext hat sich geändert.", "AbortError");
  };
}

/** Identifies the current protected context for in-memory hand-offs between pages. */
export function dataContextGeneration(): number | null {
  return owner ? generation : null;
}
